/**
 * Validates that a PDF URL is from a trusted source
 * Only allows URLs from Supabase storage or trusted domains
 */
export function isValidPdfUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  
  try {
    const parsedUrl = new URL(url);
    
    // Allow Supabase storage URLs
    const supabaseProjectId = import.meta.env.VITE_SUPABASE_PROJECT_ID;
    if (supabaseProjectId && parsedUrl.hostname.includes(`${supabaseProjectId}.supabase`)) {
      return true;
    }
    
    // Allow lovable.app storage URLs
    if (parsedUrl.hostname.endsWith('.lovable.app')) {
      return true;
    }
    
    // Allow supabase.co storage URLs
    if (parsedUrl.hostname.endsWith('.supabase.co')) {
      return true;
    }

    // Allow relative URLs (same origin)
    if (url.startsWith('/')) {
      return true;
    }
    
    return false;
  } catch {
    // Invalid URL
    return false;
  }
}
